import { Tag } from '@cian/components';
import * as React from 'react';

import { IKitchenAreaTag } from '../../../state/tags/definitions/kitchen_area';
import { ILivingAreaTag } from '../../../state/tags/definitions/living_area';
import { IRoomAreaTag } from '../../../state/tags/definitions/room_area';
import { ISiteAreaTag } from '../../../state/tags/definitions/site_area';
import { ITotalAreaTag } from '../../../state/tags/definitions/total_area';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IAreaTagItemProps {
  tag: ITotalAreaTag | IKitchenAreaTag | ILivingAreaTag | ISiteAreaTag | IRoomAreaTag;
  title?: string;
  unit?: string;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const AreaTagItem: React.StatelessComponent<IAreaTagItemProps> = props => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);
  let text = [];

  if (props.tag.min !== undefined) {
    text.push(`от ${props.tag.min}`);
  }

  if (props.tag.max !== undefined) {
    text.push(`до ${props.tag.max}`);
  }

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {`${props.title} ${text.join(' ')} ${props.unit}`}
    </TagComponent>
  );
};

AreaTagItem.defaultProps = {
  title: 'Площадь',
  unit: 'м\u00B2',
};
